import { useMemo } from 'react';
import { ProfileEditFormFields } from '@features/current-user/edit-profile/ui/profile-edit/types';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';

export const useNormalizeInitialValues = () => {
    const user = useCurrentUserSelector();
    const initialValues = useMemo(() => {
        const departmentOption = user?.department
            ? [
                  {
                      label: user?.department.name,
                      value: String(user.department.id),
                  },
              ]
            : [];
        const result: ProfileEditFormFields = {
            'profile-name': user?.firstName || '',
            'profile-surname': user?.lastName || '',
            'profile-patronymic': user?.middleName || '',
            'profile-job-title': user?.jobTitle || '',
            'profile-phone': user?.phoneNumber || '',
            'profile-agreement-advert': user?.receivingPromotionalMaterials || false,
            'profile-department': departmentOption,
        };
        return result;
    }, [user]);

    return initialValues;
};
